import React from 'react';
import { makeStyles } from '@mui/styles';
import { Hidden, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useRouter } from 'next/router';
import Image from 'next/image';

import i18next from 'i18next';
import StyledMenu from 'components/StyledMenu';
import StyledMenuItem from 'components/StyledMenuItem';

const useStyles = makeStyles(theme => ({
  langContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    marginRight: theme.spacing(3),
    '& .MuiTypography-body1': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(0.5),
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: '90px',
    },

    [theme.breakpoints.down('lg')]: {
      minWidth: '30px',
    },

    height: 30,
    cursor: 'pointer',
    '&:hover': {
      borderRadius: 2,
      backgroundColor: '#ffffff4d',
    },
  },
}));

const LangDropdown = ({ lang }) => {
  const classes = useStyles();
  const router = useRouter();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = newLang => {
    i18next.changeLanguage(newLang);
    router.push(router.pathname.replace('/[lang]', `/${newLang}`));
    handleClose();
  };

  return (
    <>
      <div onClick={handleClick} className={classes.langContainer}>
        <Image
          unoptimized={true}
          height={16}
          width={16}
          alt={lang === 'en' ? 'English' : 'עברית'}
          src={`/images/${lang === 'en' ? 'en_icon' : 'he_icon'}.png`}
        />
        <Hidden lgDown>
          <Typography>{lang === 'en' ? 'English' : 'עברית'}</Typography>
          <KeyboardArrowDownIcon />
        </Hidden>
      </div>
      <StyledMenu
        disableScrollLock={true}
        id="customized-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <StyledMenuItem onClick={() => handleChange('en')}>
          <Image unoptimized={true} height={16} width={16} src="/images/en_icon.png" alt={'English'} />
          <Hidden lgDown>
            <Typography>English</Typography>
          </Hidden>
        </StyledMenuItem>
        <StyledMenuItem onClick={() => handleChange('he')}>
          <Image unoptimized={true} height={16} width={16} src="/images/he_icon.png" alt={'עברית'} />
          <Hidden lgDown>
            <Typography>עברית</Typography>
          </Hidden>
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

export default LangDropdown;
